/* eslint no-multi-spaces: 0 */

import Vue         from 'vue'
import shell       from '@/components/Layouts/shell'
import publicShell from '@/components/Layouts/shell/public'

export default {
  shell: Vue.extend(shell),
  publicShell: Vue.extend(publicShell)
}



// WEBPACK FOOTER //
// ./src/components/ModulesWrapper/index.js